import React from "react";
import LoadingState from "./LoadingState";

// Shared fallback for the route-level <Suspense> boundaries in AppRoutes.
// Reuses LoadingState (same spinner + keyframe as the rest of the app) and
// centers it in the viewport while a lazy route chunk is fetched.
const SuspenseFallback: React.FC = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      width: "100%",
    }}
  >
    <LoadingState isLoading />
  </div>
);

export default SuspenseFallback;
